import WebAPIUtils from '../../WebAPIUtils';
import { getFieldName } from '../../helpers/StateInterpreters';

export const fetchSurveyStatisticsTabulated = async (farm, field, survey, layers, LangFile) => {
  let farmId = farm.farmId;
  let fieldId = field.fieldId;

  let promises = layers.map((layer) => {
    return WebAPIUtils.getLayerValues(farmId, fieldId, null, layer, survey);
  });

  let result = await Promise.all(promises);

  let stats = result.map((values) => {
    let pixels = values.flatten().filter((p) => p != null);
    let sum = pixels.reduce((partialSum, a) => partialSum + a, 0);
    let mean = sum / pixels.length;
    return Number(mean.toFixed(2));
  });

  let items = [fieldId, getFieldName(field, LangFile), Number(field.size.toFixed(2)), ...stats];

  return items.join('\t');
};
